import Cookies from 'universal-cookie';
import React, {Suspense, useEffect, useState, useRef} from "react";
import {safeClear} from "../../utils/safeStorage";
import {isMobileBrowser} from "../../utils/mobileDetect";
import MobileLayout from "../../components/Mobile/MobileLayout";
import {
    Button,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    NavItem,
    UncontrolledDropdown,
    UncontrolledTooltip,
    Row,
} from "reactstrap";
import {useNavigate, useLocation, Link, Outlet} from "react-router-dom";
import {Tooltip} from "react-tooltip";
import ProfileImage from "../../components/core/ProfileImage";
import useAppContext from "../../hooks/useAppHook";
import useObjectContext from "../../hooks/useObjectHook";
import {Search} from "../../components/SearchDashboard/Search";
import {DropDownFilterPanel} from "../../components/DropDownFilterPanel/DropDownFilterPanel";
import {isCalendarEnabled, isUserComplate, querystring, visibility} from "../../utils/Utility";
import {getInitial} from "../../utils/StringUtil";
import UserProfile from "../../components/User/UserProfile";
import {EventEmitter} from "../../services/event";
import FullViewIcon from "../../assets/img/reduce.svg"
/* eslint-disable */
import {BehaviourContextProvider, ObjectContextProvider, CategoryContextProvider} from "../../context/AppStore";
import useBehaviourContext from "../../hooks/useBehaviourHook";
import PropTypes from "prop-types";
import FormPasswordReset from "../../components/User/changePassword";
import Loading from "../../components/core/Loading";
import {callAxiosServiceWithParam} from "../../services/callAxios";
import RenderIntegrationItem, {AppCategories} from "../../components/ExternalApps/AppInstaller";
import {InfoModal} from "../../components/Dashboard/InfoModal"
import {canViewTeamPulse} from "../../utils/teamPulseAccess";
import UploadMeeting from "../../components/modalComponent/UploadMeeting";
import LiveMeeting from "../../components/modalComponent/LiveMeeting";
import FilterPanel from "../../components/core/Filters/FilterPanel";
import {SaveSearchModal} from "../../components/Dashboard/SaveSearchModal";
import '../../components/core/Sidebar.css';


const propTypes = {
    children: PropTypes.node,
};

const defaultProps = {};

function DashBoard(props) {
    const {showSearchPanel, setShowSearchPanel} = useBehaviourContext();
    return (
        <NavItem style={{marginTop: "12px"}}>
            <reactstrapNavLink href="#" onClick={() => setShowSearchPanel(!showSearchPanel)}>
                <i className="nav-icon fa fa-dashboard"></i>
                Dashboard
            </reactstrapNavLink>
        </NavItem>
    );
}

function ProfileMenu(props) {

    return (
        <UncontrolledDropdown className="meetingmenu" direction="down" active>
            <DropdownToggle nav>
                <i className="meeting-first-row-action"/>
            </DropdownToggle>
            <DropdownMenu end className="sub-menu">
                <DropdownItem onClick={(e) => {
                }} className="sharedto">
                    <i className="sharedto-icon"></i>
                    Share with
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
    );
}

function SearchFilter(props) {
    const {expandFilterPanel, setExpandFilterPanel} = useBehaviourContext();
    return (
        <NavItem style={{marginTop: "12px"}}>
            <reactstrapNavLink
                href="#"
                onClick={() => setExpandFilterPanel(!expandFilterPanel)}
            >
                <i className="nav-icon fa fa-search"></i>
                Filters
            </reactstrapNavLink>
        </NavItem>
    );
}

function UserCreationLink(props) {
    return (
        <>
            <reactstrapNavLink to="" id="userProfile" href="#" className="nav-link">
                Profile
            </reactstrapNavLink>
            <UserProfile targetId="userProfile"></UserProfile>
        </>
    );
}

function Profile(props) {

    const {user, setPhotoUrl, photoUrl, setUser, mode} = useAppContext();
    const {setHideMeetingPanel, setExtraLeftPanel} = useBehaviourContext();
    const [isOpen, setIsOpen] = useState(false);
    const [isOnboardingOpen, setIsOnboardingOpen] = useState(false);
    const [bioMetricUrl, setBiometricUrl] = useState(user.bioMetricUrl);
    const [toggleError, setToggleError] = useState(false)
    const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false)


    useEffect(() => {
        setHideMeetingPanel(false);
        setExtraLeftPanel("");
    }, [props.active])

    async function fetchData() {
        let url = user?.customer?.id + "/biometrics/" + user?.id;
        let filePath = await callAxiosServiceWithParam(
            "users/signedurl",
            "filepath=" + encodeURIComponent(url)
        )
        if (!filePath || filePath.data == '') {
            return Promise.resolve("");
        } else {
            //Uncaught (in promise) TypeError: Cannot assign to read only property 'bioMetricUrl' of object '#<Object>'
            //Need to call setUser
            // user.bioMetricUrl = url;
            setBiometricUrl(filePath.data)
            return Promise.resolve("");
        }
    }

    const toggle = (event, newBioMetricUrl) => {
        if (bioMetricUrl || newBioMetricUrl) {
            if (newBioMetricUrl) {
                fetchData().then(e => {
                    setIsOpen(false);
                })
            } else {
                setIsOpen(!isOpen);
            }
        } else {
            setIsOpen(!isOpen);
        }
    }

    const toggleOnbarding = (event, show = false) => {
        if (!isUserComplate(user) || !isCalendarEnabled(user)) {
            setIsOnboardingOpen(true);
        } else {
            setIsOnboardingOpen(show);
        }
    }
    const [isPasswordOpen, setIsPasswordOpen] = useState(false);
    const togglePassword = () => setIsPasswordOpen(!isPasswordOpen);

    const [isInfoModalOpen, setIsInfoModalOpen] = useState(querystring("panel"));
    const toggleInfo = () => setIsInfoModalOpen(!isInfoModalOpen);

    useEffect(() => {
        if (user && !photoUrl) {
            callAxiosServiceWithParam(
                "users/signedurl",
                "filepath=" + encodeURIComponent(photoUrl)
            )
                .then((filePath) => {
                    setPhotoUrl(filePath.data);
                })
                .catch((e) => {
                });
        }
    }, [photoUrl]);
    useEffect(() => {
        if (bioMetricUrl && !bioMetricUrl.startsWith("http")) {
            fetchData().then(e => {
            })
        } else if (user.bioMetricUrl && !user.bioMetricUrl.startsWith("http")) {
            fetchData().then(e => {
            })
        }

        if (!isOnboardingOpen && isUserComplate(user) && isCalendarEnabled(user)) {
            toggleOnbarding(null, false)
        } else {
            toggleOnbarding(null, true)
        }
    }, [user, user.bioMetricUrl]);

    // useEffect(() => {
    //      if (registeredApps) {
    //          registeredApps.forEach((provider) => {
    //              if (provider.category == AppCategories.MEETINGS && provider.status == AppProviderStatus.INSTALLED)  {
    //                  setIsConferenceDone(true)
    //              }
    //          })
    //      }
    //  });

    return (
        <div>
            <UncontrolledDropdown nav direction="right" tag="div">
                <DropdownToggle nav style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <ProfileImage
                        className="rounded-img1"
                        photoUrl={photoUrl}
                        text={getInitial(user.firstName, user.lastName)}
                    />
                    <span className="rf-sidebar-profile-name rf-sidebar-label">{user.firstName || ''}</span>
                </DropdownToggle>
                <DropdownMenu left="true">
                    <DropdownItem id="btnUserProfile" onClick={toggle} type={"link"}>
                        Profile
                    </DropdownItem>
                    <DropdownItem
                        id="btnChangePassword"
                        onClick={togglePassword}
                        type={"link"}
                    >
                        Change Password
                    </DropdownItem>
                    <DropdownItem onClick={() => setLogoutConfirmOpen(true)}>
                        Logout
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
            <ModalProfile
                isOpen={isOpen}
                toggle={toggle}
                toggleError={toggleError}
                bioMetricUrl={bioMetricUrl}
            ></ModalProfile>
            <ModalInfo
                isOpen={isInfoModalOpen}
                toggle={toggleInfo}
            ></ModalInfo>
            {/*<InitialOnboardingModal*/}
            {/*    isOpen={isOnboardingOpen}*/}
            {/*    toggle={toggleOnbarding}*/}
            {/*    toggleError={toggleError}*/}
            {/*    bioMetricUrl={bioMetricUrl}*/}
            {/*></InitialOnboardingModal>*/}
            <ModalPassword
                isOpen={isPasswordOpen}
                toggle={togglePassword}
            ></ModalPassword>
            <Modal isOpen={logoutConfirmOpen} toggle={() => setLogoutConfirmOpen(false)} centered size="sm" className="logout-confirm-modal">
                <ModalHeader toggle={() => setLogoutConfirmOpen(false)}>Confirm Logout</ModalHeader>
                <ModalBody>
                    Are you sure you want to log out?
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setLogoutConfirmOpen(false)}>Cancel</Button>
                    <Button className="btn-typography-primary" onClick={(e) => { setLogoutConfirmOpen(false); props.onLogout(e); }}>Logout</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

function ModalInfo(props) {
    const [infoModalOpen, setInfoModalOpen] = useState(false)
    const toggleSharedOpen = () => {
        props.toggle()
    };
    return (
        <Modal
            size="md"
            className="appProvider-container"
            isOpen={props.isOpen}
            toggle={props.toggle}
            placement="auto-end"
            centered={true}
            target={props.targetId}
        >
            <ModalHeader toggle={props.toggle} charCode="x"
                         style={{border: "none", display: "flex", justifyContent: "center", alignItems: "center",}}
            >
                <span style={{fontSize: "24px", padding: "20px", fontWeight: 600}}>
                    Important Tips
                </span>
            </ModalHeader>
            <ModalBody>
                <InfoModal
                    targetId="btnUserProfile"
                    toggle={props.toggle}
                    toggleError={props.toggleError}
                    bioMetricUrl={props.bioMetricUrl}
                ></InfoModal>
            </ModalBody>
            <ModalFooter style={{borderTop: "0 none"}}>
                <div style={{padding: 10}}>
                    <Button color="primary" style={{background: '#0052cc', color: '#fff', marginTop: "-30"}}
                            onClick={(e) => {
                                props.toggle();
                                window.location.href = '/#/sexttings?panel=5'
                            }}>Modify Settings
                    </Button>
                </div>
                {"  "}
                <div style={{padding: 10}}>
                    <Button color="primary" style={{background: '#0052cc', color: '#fff', marginTop: "-30"}}
                            onClick={(e) => {
                                toggleSharedOpen()
                            }}>Continue
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    );
}

function ModalProfile(props) {
    return (
        <Modal
            size="lg"
            className="appProvider-container"
            isOpen={props.isOpen}
            toggle={props.toggle}
            placement="auto-end"
            target={props.targetId}
        >
            <ModalHeader
                toggle={props.toggle}
                charCode="x"
                style={{paddingBottom: 0, borderBottom: "none"}}
            >
                <span style={{fontSize: "20px", fontWeight: 700, color: 'var(--rf-text-primary, #111827)', letterSpacing: '-0.02em'}}>
                    User Profile
                </span>
            </ModalHeader>
            <ModalBody>
                <UserProfile
                    targetId="btnUserProfile"
                    toggle={props.toggle}
                    toggleError={props.toggleError}
                    bioMetricUrl={props.bioMetricUrl}
                ></UserProfile>
            </ModalBody>
        </Modal>
    );
}

function ModalPassword(props) {
    let currentPassword = "";
    let newPassword = "";
    const {toggle, row} = props;
    return (
        <Modal
            size="sm"
            className="aum-list"
            isOpen={props.isOpen}
            toggle={props.toggle}
            placement="auto-end"
            target={props.targetId}
        >
            <ModalHeader toggle={props.toggle} charCode="x" className="font-24">
                <h2>
                    <b>Change Password</b>
                </h2>
            </ModalHeader>
            <ModalBody>
                <FormPasswordReset
                    targetId="btnChangePassword"
                    toggle={props.toggle}
                ></FormPasswordReset>
            </ModalBody>
        </Modal>
    );
}

function ModalConference(props) {
    return (
        <Modal
            size="xl"
            className="appProvider-container"
            isOpen={props.isOpen}
            toggle={props.toggle}
            placement="auto-end"
            target={props.targetId}
        >
            <ModalHeader
                toggle={props.toggle}
                charCode="x"
                style={{paddingBottom: 0, border: "none"}}
            >
                <span style={{fontSize: "24px", paddingLeft: "20px"}}>
                    Web Conference Integration
                </span>
            </ModalHeader>
            <ModalBody>
                {props.error && <h3 style={{color: "red"}}>Please finish integrating a web conference</h3>}
                <RenderIntegrationItem
                    category={AppCategories.MEETINGS} isOnboardingFlow={true}>
                </RenderIntegrationItem>
            </ModalBody>
        </Modal>
    );
}

function ModalLiveMeeting(props) {
    return (
        <Modal
            className="appProvider-container"
            isOpen={props.isOpen}
            toggle={props.toggle}
            placement="auto-end"
            centered={true}
        >
            <ModalHeader
                toggle={props.toggle}
                charCode="x"
                style={{paddingBottom: 0, border: "none"}}
            >
                <span style={{fontSize: "24px", paddingLeft: "20px"}}>
                    Add Rafiki NoteTaker to a Live Call
                </span>
            </ModalHeader>
            <ModalBody>
                <LiveMeeting
                    toggle={props.toggle}
                ></LiveMeeting>
            </ModalBody>
        </Modal>
    );
}

const DefaultLayout = () => {
    const navigate = useNavigate();
    const [hasCrmIntegration, setHasCrmIntegration] = useState(false);
    const [execute, setExecute] = useState(false);
    const [activeNav, setActiveNav] = useState("meeting");
    const [open, isOpen] = useState(false);
    const active = () => isOpen(!open);
    const location = useLocation();
    const {isFilterTopNav, setFilterTopNav} = useBehaviourContext();
    const {user, setUser, mode, msalInstance, navMeetId, filterData, setFilterData,} = useAppContext();
    const {setIsPlaying} = useObjectContext();
    const loading = () => <Loading></Loading>;
    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const toggleTT = (_) => setTooltipOpen(tooltipOpen ? false : true);
    const [tooltipVLOpen, setTooltipVLOpen] = React.useState(false);
    const toggleVL = (_) => setTooltipVLOpen(tooltipVLOpen ? false : true);
    const onClickActiveNav = (active) => setActiveNav(active);
    const [licenseMsg, setLicenseMsg] = useState("");
    const [upgradeUrl, setUpgradeUrl] = useState("/#/settings?tab=5");
    const [isUploadOpen, setIsUploadOpen] = React.useState(false);
    const toggleUploadModalOpen = () => setIsUploadOpen(!isUploadOpen);
    const [isOpenFilter, setIsFilterOpen] = useState(false);
    const toggleFilter = () => setIsFilterOpen(!isOpenFilter);
    const [isFiltered, setIsFiltered] = useState(false);
    const [filterForm, setFilterForm] = useState({});
    const [popoverOpen, setPopoverOpen] = useState(false);
    const togglePO = () => setPopoverOpen(!popoverOpen);
    const [tooltipUpgradeOpen, setTooltipUpgradeOpen] = React.useState(false);
    const toggleUpgrade = (_) => setTooltipUpgradeOpen(tooltipUpgradeOpen ? false : true);
    const [showBanner, setShowBanner] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [isSaveOpen, setIsSaveOpen] = useState(false);
    const toggleSaveOpen = () => {
        setIsPlaying(false);
        setIsSaveOpen(!isSaveOpen);
    }
    const searchRef = useRef();
    const clearSearch = () => {
        if (searchRef.current) {
            searchRef.current.clear();
        }
    }

    // Mobile phone browser: show minimal meeting list + player view
    if (isMobileBrowser()) {
        return (
            <MobileLayout
                user={user}
                msalInstance={msalInstance}
                setUser={setUser}
                navigate={navigate}
            />
        );
    }

    function isChrome() {
        return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    }

    function checkExtension(extensionId) {
        return new Promise((resolve) => {
            if (!isChrome()) {
                resolve(false);
            } else {
                chrome.runtime?.sendMessage(
                    extensionId,
                    {type: "GET_VERSION"},
                    (response) => {
                        if (chrome.runtime?.lastError) {
                            resolve(false);
                        } else {
                            resolve(response);
                        }
                    }
                );
            }
        });
    }

    function withinThreeWeeks(date) {
        const threeWeeksInMilliseconds = 21 * 24 * 60 * 60 * 1000;
        const diff = Date.now() - date.getTime();
        return diff <= threeWeeksInMilliseconds;
    }

    useEffect(() => {
        async function checkExtensionAndUpdateState() {
            const response = await checkExtension(process.env.REACT_APP_CHROME_EXTENSION_ID);
            if (!response || response.version !== process.env.REACT_APP_CHROME_EXTENSION_VERSION &&
                withinThreeWeeks(new Date(process.env.REAACT_APP_CHROME_EXTENSION_DATE))) {
                setShowBanner(true);
                setTimeout(() => {
                    setShowBanner(false);
                }, 5000); // Hide the banner after 5 seconds
            }
        }

        checkExtensionAndUpdateState();
    }, []);

    const [liveMeetOpen, liveMeetSetOpen] = useState(false);
    const toggleLM = () => liveMeetSetOpen(!liveMeetOpen);
    // const [enableLiveMeetOpen, setEnableLiveMeetOpen] = useState(true);
    // const {meetings} = useObjectHook();
    const [calendar, setCalendar] = useState(false);
    useEffect(() => {
        if (user) {
            const myCalendar = user?.providers?.filter((e) => {
                return (
                    (e?.provider?.toLowerCase() === "google" || e?.provider?.toLowerCase() === "microsoft") &&
                    e?.service?.toLowerCase() === "calendar"
                )
            });
            if (myCalendar && myCalendar?.length > 0) {
                setCalendar(myCalendar[0]?.accessToken);
            }
        }
    }, [user]);

    useEffect(() => {
        if (user) {
            let start = new Date(user.trialStarted);
            let end = new Date(user.trialEnded);
            let now = new Date();
            const date1utc = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
            const date2utc = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
            let temp = (date2utc - date1utc) / (1000 * 60 * 60 * 24);
            if (user.license === "Trial" && (now > end || now < start)) {
                setLicenseMsg('Trial has expired. Upgrade your account.')
            } else if (user.license === "Trial") {
                setLicenseMsg('Days left on Trial: ' + temp);
            } else
                setLicenseMsg("Upgrade to Premium");
            if (user.licenseConfig?.bot && user.allowNotetaker) {
                setUpgradeUrl("/#/settings?tab=6");
            } else {
                setUpgradeUrl("/#/settings?tab=6");
            }
            if (user?.providers) {
                const crmProviders = user.providers.filter(provider =>
                    provider.service.toLowerCase() === 'crm' ||
                    (user.customer && user.customer.providers &&
                        user.customer.providers.some(p => p.service.toLowerCase() === 'crm'))
                );
                setHasCrmIntegration(crmProviders.length > 0);
            }
        }
    }, [user]);

    async function signOut(e) {
        e.preventDefault();
        window.Intercom("shutdown");
        
        // Clear localStorage
        safeClear();
        
        // Clear client-side cookies
        const cookies = new Cookies();
        cookies.remove('token', { path: '/' });
        cookies.remove('googletoken', { path: '/' });
        cookies.remove('microsofttoken', { path: '/' });
        cookies.remove('salesforcetoken', { path: '/' });
        
        // Clear server-side cookies from both servers
        const repositoryUrl = `${process.env.REACT_APP_REPOSITORY_URL}/logout`;
        const externalUrl = `${process.env.REACT_APP_EXTERNAL_URL}/users/logout`;
        
        try {
            // Clear repository server cookies
            await fetch(repositoryUrl, {
                method: "get",
                credentials: "include",
            });
            
            // Clear external server cookies
            await fetch(externalUrl, {
            method: "get",
            credentials: "include",
            });
            
            // Handle MSAL logout if applicable
                if (msalInstance) {
                    msalInstance.logout();
                } else {
                    setUser(null);
                    navigate("/login");
                    window.location.reload();
                }
        } catch (err) {
            console.log("Logout error:", err);
            // Even if server logout fails, clear local state
            setUser(null);
            navigate("/login");
            window.location.reload();
        }
    }

    useEffect(() => {

        if (navMeetId) {
            const body = document.querySelector('.app-body');
            body.scrollTo(0, 0)
        }
    }, [navMeetId]);

    // Auto-collapse sidebar on 3-pane meetings view
    useEffect(() => {
        if (location?.pathname === "/meetings-full") {
            setSidebarCollapsed(true);
        }
    }, [location?.pathname]);


    const clearSearchCallBack = () => {
        setFilterForm(null);
        setIsFiltered(false);
        EventEmitter.dispatch("search_cleared", true)
    }

    const clearFilter = (e) => {
        e.preventDefault();
        clearSearch();
        setFilterForm(null);
        setIsFiltered(false);
        setFilterTopNav(false);
        setFilterData({});
        if (setIsFiltered) {
            setIsFiltered(false);
        }
    };
    const openIntercomChat = () => {
        if (window.Intercom) {
            window.Intercom('show');
        }
    };

    const loadingDiv = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

    const [showNewBadge, setShowNewBadge] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowNewBadge(false);
        }, 30000); // 30 seconds

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="app">
            {showBanner && (
                <div className="banner">
                    <span>Update your&nbsp;&nbsp;</span>
                    <a href={`https://chrome.google.com/webstore/detail/${process.env.REACT_APP_CHROME_EXTENSION_ID}`}
                       target="_blank" rel="noreferrer">Rafiki Chrome Extension</a>
                    <span>&nbsp;&nbsp;</span>
                    <p>to the latest version</p>
                </div>
            )}
            <CategoryContextProvider>
                <ObjectContextProvider>
                    <BehaviourContextProvider>
                        <div style={{height: '68px', width: '100%'}}></div>
                        <div
                            className={`header ${
                                (location?.pathname?.startsWith("/meetings")) ? " meetings-open" : ""
                            }`}
                            style={{display: "flex", justifyContent: "space-between"}}
                        >
                            <div style={{display: "flex", alignItems: "center", gap: "0px", height: "100%", marginLeft: sidebarCollapsed ? '65px' : '220px', transition: 'margin-left 0.25s ease'}}>
                                {/* Logo moved to sidebar — hide from header */}
                                <div className="nav-search-outer">
                                    <Search clearSearchCallBack={clearSearchCallBack} ref={searchRef}></Search>
                                </div>
                                {location?.pathname?.startsWith("/meetings") ? (
                                    <DropDownFilterPanel/>) : <></>}
                                {location?.pathname?.startsWith("/meetings") ?
                                    <button className={isFiltered ? "rf-topbar-btn active" : "rf-topbar-btn"}
                                         onClick={() => {
                                             toggleFilter();
                                         }} id="btnFilter" data-tooltip="Additional Filters">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width: 15, height: 15}}>
                                            <circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /><circle cx="5" cy="12" r="1" />
                                        </svg>
                                    </button> : <></>}

                                {location?.pathname?.startsWith("/meetings") && user?.licenseConfig?.upload ?
                                    <button className="rf-topbar-btn"
                                         onClick={() => {
                                             toggleUploadModalOpen();
                                         }} id="upload" data-tooltip="Upload Recording">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width: 15, height: 15}}>
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="17 8 12 3 7 8" />
                                            <line x1="12" y1="3" x2="12" y2="15" />
                                        </svg>
                                        <Modal isOpen={isUploadOpen} toggle={toggleUploadModalOpen} centered={true}
                                               contentClassName="snippet-modal" backdrop="static">
                                            <UploadMeeting targetId="upload"
                                                           isOpen={isUploadOpen}
                                                           toggle={toggleUploadModalOpen}>
                                            </UploadMeeting>
                                        </Modal>
                                    </button> : <></>}
                                {Object.keys(filterData).length !== 0 &&
                                    location?.pathname?.startsWith("/meetings") &&
                                    <>
                                        <button className="rf-topbar-action-btn rf-topbar-action-btn--primary" id={"saveLink"} onClick={toggleSaveOpen} data-tooltip="Save Filters & Setup Alert">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width: 13, height: 13}}>
                                                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                                                <polyline points="17 21 17 13 7 13 7 21" />
                                                <polyline points="7 3 7 8 15 8" />
                                            </svg>
                                            Save
                                        </button>
                                        <SaveSearchModal targetId="saveLink" isOpen={isSaveOpen}
                                                         toggle={toggleSaveOpen}/>
                                        <button className="rf-topbar-action-btn" id={"clearSearch"} onClick={clearFilter} data-tooltip="Clear all Filters">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width: 13, height: 13}}>
                                                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                                            </svg>
                                            Clear
                                        </button>
                                    </>}
                            </div>
                            <Row style={{
                                display: "flex", flexWrap: "nowrap", marginRight: "1rem", marginLeft: "4px",
                                alignItems: "center", justifyContent: "flex-end", gap: "5px", overflow: 'hidden'
                            }}>
                                <div>
                                    {(user.license === "Trial" || user.license === "Free") &&
                                        <>
                                            <Button id="upgradeHome" type="button"
                                                    className={"btn-typography-primary"}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        window.location.href = upgradeUrl
                                                    }}
                                            >
                                                <span className="hideText">UPGRADE </span>
                                                <img src={"../../assets/img/upgrade.svg"} alt={"calendar}"}
                                                     style={{width: 16, height: 20, marginLeft: "5px"}}/>
                                            </Button>
                                            <UncontrolledTooltip placement="bottom" target="upgradeHome">
                                                {licenseMsg}
                                            </UncontrolledTooltip>
                                        </>
                                    }
                                </div>
                                {(location?.pathname === "/meetings" || (location?.pathname?.startsWith("/meetings/") && location?.pathname !== "/meetings-full")) ?
                                    <div style={{
                                        margin: "0px 10px 0px 5px", float: "right",
                                        cursor: "pointer", objectFit: "contain", display: "flex",
                                        justifyContent: "flex-end",
                                    }}><img alt="" id={"switch"}
                                            style={{backgroundSize: "18px 18px", backgroundRepeat: "no-repeat",}}
                                            onClick={e => navigate("/meetings-full")} src={FullViewIcon}/>
                                        <UncontrolledTooltip placement="left-start" target="switch">
                                            Switch to 3-Pane View
                                        </UncontrolledTooltip>
                                    </div> :
                                    location?.pathname === "/meetings-full" ?
                                        <div style={{
                                            margin: "0px 10px 0px 5px", float: "right",
                                            cursor: "pointer", objectFit: "contain", display: "flex",
                                            justifyContent: "flex-end",
                                        }}><img alt="" id={"switch"}
                                                style={{backgroundSize: "18px 18px", backgroundRepeat: "no-repeat",}}
                                                onClick={e => navigate("/meetings")}
                                                src={"../../assets/img/fullview_grey.svg"}/>
                                            <UncontrolledTooltip placement="left-start" target="switch">
                                                Switch to Full-Pane View
                                            </UncontrolledTooltip>
                                        </div> :
                                        <></>}
                            </Row>
                        </div>
                        <ModalLiveMeeting toggle={toggleLM} isOpen={liveMeetOpen}></ModalLiveMeeting>
                        <FilterPanel
                            isFiltered={isFiltered}
                            setIsFiltered={setIsFiltered}
                            isOpen={isOpenFilter}
                            toggle={toggleFilter}
                            filterForm={filterForm}
                            setFilterForm={setFilterForm}
                            clearSearch={clearSearch}
                        />
                        <div className="app-body">
                            <div className={`rf-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
                                {/* Logo header */}
                                <div className="rf-sidebar-header">
                                    <img src="/assets/img/logo-icon.svg" alt="Rafiki" className="rf-sidebar-logo-img" />
                                    <span className="rf-sidebar-brand">Rafiki</span>
                                </div>

                                {/* Scrollable nav */}
                                <div className="rf-sidebar-nav">
                                    {/* MAIN section */}
                                    <div className="rf-sidebar-section">Main</div>

                                    <Link to="/home" id="home"
                                          className={`rf-sidebar-item ${location?.pathname === "/home" ? "active" : ""}`}
                                          onClick={() => onClickActiveNav("home")}>
                                        <svg className="home sidebar-icon rf-sidebar-icon"></svg>
                                        <span className="rf-sidebar-label">Home</span>
                                    </Link>

                                    <Link to="/meetings" id="meetings"
                                          className={`rf-sidebar-item ${location?.pathname?.startsWith("/meetings") ? "active" : ""}`}
                                          onClick={() => onClickActiveNav("meeting")}>
                                        <svg className="video sidebar-icon rf-sidebar-icon"></svg>
                                        <span className="rf-sidebar-label">Meetings</span>
                                    </Link>

                                    {hasCrmIntegration && (
                                        <Link to="/deals-full" id="deals"
                                              className={`rf-sidebar-item ${location?.pathname === "/deals-full" ? "active" : ""}`}
                                              onClick={() => onClickActiveNav("deal")}>
                                            <svg className="deals sidebar-icon rf-sidebar-icon"></svg>
                                            <span className="rf-sidebar-label">Deals</span>
                                        </Link>
                                    )}

                                    {/* INTELLIGENCE section */}
                                    {(user.license === "Premium" || user.license === "Trial") && user?.showAsk === true && (
                                        <>
                                            <div className="rf-sidebar-section">Intelligence</div>
                                            <Link to="/answer-engine" id="answer-engine"
                                                  className={`rf-sidebar-item ${location?.pathname === "/answer-engine" ? "active" : ""}`}
                                                  onClick={() => { onClickActiveNav("answer-engine"); if (window.resetAnswerEngineConversation) window.resetAnswerEngineConversation(); }}>
                                                <svg className="magic sidebar-icon rf-sidebar-icon"></svg>
                                                <span className="rf-sidebar-label">Ask Rafiki</span>
                                            </Link>
                                            <Link to="/genai-grid" id="genai-grid"
                                                  className={`rf-sidebar-item ${location?.pathname === "/genai-grid" ? "active" : ""}`}
                                                  onClick={() => onClickActiveNav("genai-grid")}>
                                                <svg className="gengrid sidebar-icon rf-sidebar-icon"></svg>
                                                <span className="rf-sidebar-label">AI Reports</span>
                                            </Link>
                                        </>
                                    )}

                                    {/* ANALYTICS section */}
                                    <div className="rf-sidebar-section">Analytics</div>

                                    <Link to="/playlists" id="playlists"
                                          className={`rf-sidebar-item ${location?.pathname === "/playlists" ? "active" : ""}`}
                                          onClick={() => onClickActiveNav("playlists")}>
                                        <svg className="playlists sidebar-icon rf-sidebar-icon"></svg>
                                        <span className="rf-sidebar-label">Playlists</span>
                                    </Link>

                                    {canViewTeamPulse(user) && (
                                        <Link to="/analytics" id="analytics"
                                              className={`rf-sidebar-item ${location?.pathname === "/analytics" ? "active" : ""}`}
                                              onClick={() => onClickActiveNav("analytics")}>
                                            <svg className="analytics sidebar-icon rf-sidebar-icon"></svg>
                                            <span className="rf-sidebar-label">Team Pulse</span>
                                        </Link>
                                    )}

                                    <Link to="/coaching" id="coaching"
                                          className={`rf-sidebar-item ${location?.pathname === "/coaching" ? "active" : ""}`}
                                          onClick={() => onClickActiveNav("coaching")}>
                                        <svg className="coaching sidebar-icon rf-sidebar-icon"></svg>
                                        <span className="rf-sidebar-label">Coaching</span>
                                    </Link>

                                    {/* TOOLS section */}
                                    {(user?.voiceAgents || user?.customer?.rolePlayConfig?.enabled) && (
                                        <>
                                            <div className="rf-sidebar-section">Tools</div>
                                            {user?.customer?.rolePlayConfig?.enabled && (
                                                <Link to="/roleplay" id="roleplay"
                                                      className={`rf-sidebar-item ${location?.pathname === "/roleplay" ? "active" : ""}`}
                                                      onClick={() => onClickActiveNav("roleplay")}>
                                                    <svg className="roleplay sidebar-icon rf-sidebar-icon"></svg>
                                                    <span className="rf-sidebar-label">Role Play</span>
                                                </Link>
                                            )}
                                            {user?.voiceAgents && (
                                                <Link to="/agents" id="voiceagents"
                                                      className={`rf-sidebar-item ${location?.pathname === "/agents" ? "active" : ""}`}
                                                      onClick={() => onClickActiveNav("agents")}>
                                                    <svg className="agents sidebar-icon rf-sidebar-icon"></svg>
                                                    <span className="rf-sidebar-label">Voice Agents</span>
                                                </Link>
                                            )}
                                        </>
                                    )}
                                </div>

                                {/* Footer */}
                                <div className="rf-sidebar-footer">
                                    <a target="_blank" rel="noreferrer" id="videolibrary"
                                       href="https://docs.getrafiki.ai/en/articles/5258794-video-help-librarys"
                                       className="rf-sidebar-item" style={{visibility: visibility()}}>
                                        <img src="/assets/img/help.svg" alt="Help" className="rf-sidebar-icon" />
                                        <span className="rf-sidebar-label">Help</span>
                                    </a>
                                    <Link to="/home" id="intercom" className="rf-sidebar-item">
                                        <img src="/assets/img/intercom-2.svg" alt="Live Chat" className="rf-sidebar-icon" />
                                        <span className="rf-sidebar-label">Live Chat</span>
                                    </Link>
                                    <Link to="/settings" id="settings"
                                          className={`rf-sidebar-item ${location?.pathname === "/settings" ? "active" : ""}`}>
                                        <img alt="Settings" src="/assets/img/setting_gray.svg" className="rf-sidebar-icon" />
                                        <span className="rf-sidebar-label">Settings</span>
                                    </Link>
                                    <div className="rf-sidebar-profile-row">
                                        <Profile active={activeNav} onLogout={signOut}></Profile>
                                    </div>
                                    <button className="rf-sidebar-collapse-btn"
                                            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                                            title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="rf-collapse-icon">
                                            <polyline points="11 17 6 12 11 7"></polyline>
                                            <polyline points="18 17 13 12 18 7"></polyline>
                                        </svg>
                                        <span className="rf-sidebar-collapse-label">{sidebarCollapsed ? 'Expand' : 'Collapse'}</span>
                                    </button>
                                </div>
                            </div>
                                    <main className={`main${location?.pathname === "/meetings-full" ? " meetings-full" : ""}`} id="scrollableDiv"
                                  style={{borderTop: "none", paddingLeft: sidebarCollapsed ? '65px' : '220px', transition: 'padding-left 0.25s ease'}}>
                                <Suspense fallback={loadingDiv()}>
                                    <Outlet></Outlet>
                                </Suspense>
                            </main>
                        </div>
                    </BehaviourContextProvider>
                </ObjectContextProvider>
            </CategoryContextProvider>
        </div>
    );
};
DefaultLayout.propTypes = propTypes;
DefaultLayout.defaultProps = defaultProps;
export default DefaultLayout;
